import styled from 'styled-components/native'

export const StyledScroll = styled.ScrollView`
    display: flex;
    flex-direction: column;
    height: 680px;
    padding: 16px;
`